const MAX_DT_SEC = 0.1;

export class LoopClock {
  private last: number | undefined;

  /** Real-time delta in seconds, clamped so a long hidden tab or a clock hiccup never explodes a frame. */
  tick(realNowMs: number): number {
    const dt = this.last === undefined ? 0 : (realNowMs - this.last) / 1000;
    this.last = realNowMs;
    return Math.min(MAX_DT_SEC, Math.max(0, dt));
  }
}

/** rAF loop paused while the tab is hidden. Returns stop(). */
export function startLoop(frame: (realNowMs: number, dtSec: number) => void): () => void {
  const clock = new LoopClock();
  let handle = 0;
  let running = true;

  const step = (): void => {
    if (!running) return;
    const now = Date.now();
    frame(now, clock.tick(now));
    handle = requestAnimationFrame(step);
  };

  const onVisibility = (): void => {
    cancelAnimationFrame(handle);
    if (!document.hidden && running) handle = requestAnimationFrame(step);
  };

  document.addEventListener('visibilitychange', onVisibility);
  handle = requestAnimationFrame(step);

  return () => {
    running = false;
    cancelAnimationFrame(handle);
    document.removeEventListener('visibilitychange', onVisibility);
  };
}
